import CertificatesTable from 'components/certificates-table/certificates-table';
import ArrowLeftIcon from 'components/icons/ArrowLeftIcon';
import { RETIRE_PAGE } from 'site-settings/site-navigation';
import {
  ButtonsPosition,
  ButtonNavLink
} from 'components/common/button/button';

import { Wrapper } from 'assets/styles/pages.style';

const CertificatesPage = () => {
  return (
    <Wrapper>
      <ButtonsPosition position="left">
        <ButtonNavLink to={RETIRE_PAGE}>
          <ArrowLeftIcon />
        </ButtonNavLink>
      </ButtonsPosition>
      <CertificatesTable />
    </Wrapper>
  );
};

export default CertificatesPage;
